"use strict";
var logo = document.querySelector(".logo");
var successMessage = "Promise was resolved!";
var errorMessage = "Promise was rejected!";
var promise1 = new Promise(function(resolve, reject) {
    logo.addEventListener("click", function() {
        resolve();
    });
});
var promise2 = new Promise(function(resolve, reject) {
    setTimeout(function() {
        reject(new Error("Timeout"));
    }, 3000);
});
function succesHandler() {
    var div = document.createElement("div");
    div.className = "message";
    div.textContent = successMessage;
    document.body.appendChild(div);
}
function errorHandler() {
    var div = document.createElement("div");
    div.className = "message error-message";
    div.textContent = errorMessage;
    document.body.appendChild(div);
}
promise1.then(succesHandler).catch(errorHandler);
promise2.then(succesHandler).catch(errorHandler); // write your code here

//# sourceMappingURL=index.4ee1eae8.js.map
